import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTopButton from '../components/ScrollToTopButton';
// import BubbleCursor from '../components/BubbleCursor';

const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white text-gray-900">
      <Header />
      <main className="flex-grow bg-white">
        {children}
      </main>
      <Footer />
      <ScrollToTopButton/>
      {/* <BubbleCursor/> */}
    </div>
  );
};

export default MainLayout;

